

export const NOT_SET_VALUES = [undefined, '', null]; // sorted by most probable

export const MARKETING_NAME_SUBTITLE_CODES = ['microsoft-365', 'ai-builder'];
